import request from '@/utils/request'



export default {
  // 列表
  watchBook(bookId,viewId) {
    return request({
      url: `/year/readBook/watch/${bookId}/${viewId}`,
      method: 'get'
    })
  }
}